import { Class } from '../../common';

var ChartPlotArea = (function (Class) {
    function ChartPlotArea(plotArea) {
        Class.call(this);

        this._plotArea = plotArea;
        this.visual = plotArea.visual;
        this.backgroundVisual = plotArea._bgVisual;
    }

    if ( Class ) ChartPlotArea.__proto__ = Class;
    ChartPlotArea.prototype = Object.create( Class && Class.prototype );
    ChartPlotArea.prototype.constructor = ChartPlotArea;

    return ChartPlotArea;
}(Class));

export default ChartPlotArea;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@progress/kendo-charts/dist/es/chart/api-elements/chart-plotarea.js
// module id = 2394
// module chunks = 29